/**
 * Compact mode hook - manages table compact mode via user settings
 * Migrated from localStorage to Firestore user settings for cross-device sync
 */
import useUserSettings from '@/features/settings/hooks/api';

export interface UseCompactModeReturn {
  compactMode: boolean;
  setCompactMode: (value: boolean) => void;
  toggleCompactMode: () => void;
}

export default function useCompactMode(): UseCompactModeReturn {
  const { settings, updateSettings } = useUserSettings();

  const setCompactMode = (value: boolean) => {
    updateSettings({ compactTable: value });
  };

  const toggleCompactMode = () => {
    updateSettings({ compactTable: !settings.compactTable });
  };

  return {
    compactMode: settings.compactTable,
    setCompactMode,
    toggleCompactMode,
  };
}
